import { Workflow, ScanLine, Radio, FolderOpen } from "lucide-react";
import { Panel, Bar } from "./Panel";

const PIPE = [
  ["da_preparare", "Da preparare", "#F59E0B"],
  ["stampati", "Stampati", "#3B82F6"],
  ["inviati", "Inviati", "#10B981"],
];
const COURIERS = [["GLS", "GLS", "#EAB308"], ["NAPOLI", "Napoli", "#A78BFA"], ["TIKTOK", "TikTok", "#EC4899"]];
const SUB = [["POSTE", "Poste"], ["IMILE", "iMile"], ["BRT", "BRT"], ["ALTRO", "Altro"]];
const CHANNELS = [["website", "Sito web", "#60A5FA"], ["whatsapp", "WhatsApp", "#34D399"], ["tiktok_shop", "TikTok Shop", "#22D3EE"]];
const FOLDERS = [["GLS", "GLS", "#EAB308"], ["NAPOLI", "Napoli", "#A78BFA"], ["PERSONALIZZATO", "Personalizzati", "#34D399"]];

export const PipelinePanel = ({ pipeline }) => {
  const total = Object.values(pipeline).reduce((a, b) => a + b, 0);
  return (
    <Panel title="Ordini di oggi" icon={Workflow} testid="orders-pipeline-card" to="/sales" action="Archivio" delay={80}>
      <div className="grid grid-cols-3 gap-3">
        {PIPE.map(([k, label, color]) => (
          <div key={k} className="rounded-xl bg-white/[0.03] border border-white/5 p-3">
            <p className="font-mono font-bold text-3xl text-white tabular-nums" data-testid={`pipeline-${k}-count`}>{pipeline[k]}</p>
            <p className="text-[11px] text-zinc-400 mb-2">{label}</p>
            <Bar value={pipeline[k]} max={total} color={color} />
          </div>
        ))}
      </div>
    </Panel>
  );
};

export const ScansPanel = ({ scans, total, tiktok }) => (
  <Panel title="Pacchi sparati oggi" icon={ScanLine} testid="courier-scans-card" to="/scanner" action="Scanner" delay={140}>
    <p className="font-mono font-extrabold text-5xl text-white tabular-nums mb-4" data-testid="scans-total">{total}</p>
    <div className="space-y-3">
      {COURIERS.map(([k, label, color]) => (
        <div key={k}>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-zinc-300 flex items-center gap-2"><span className="w-2 h-2 rounded-full" style={{ background: color }} />{label}</span>
            <span className="font-mono font-bold text-white" data-testid={`courier-${k.toLowerCase()}-count`}>{scans[k]}</span>
          </div>
          <Bar value={scans[k]} max={total} color={color} />
        </div>
      ))}
    </div>
    <div className="mt-4 grid grid-cols-4 gap-2">
      {SUB.map(([k, label]) => (
        <div key={k} className="text-center rounded-lg bg-pink-500/5 border border-pink-500/20 py-2">
          <p className="font-mono font-bold text-pink-200" data-testid={`tiktok-sub-${k.toLowerCase()}`}>{tiktok[k]}</p>
          <p className="text-[10px] text-zinc-500">{label}</p>
        </div>
      ))}
    </div>
  </Panel>
);

const CountList = ({ items, data, prefix }) => {
  const max = Math.max(1, ...items.map(([k]) => data[k] || 0));
  return (
    <div className="space-y-3">
      {items.map(([k, label, color]) => (
        <div key={k}>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-zinc-300">{label}</span>
            <span className="font-mono font-bold text-white" data-testid={`${prefix}-${k.toLowerCase()}-count`}>{data[k] || 0}</span>
          </div>
          <Bar value={data[k] || 0} max={max} color={color} />
        </div>
      ))}
    </div>
  );
};

export const ChannelsPanel = ({ channels }) => (
  <Panel title="Canali oggi" icon={Radio} testid="sales-channels-card" delay={200}>
    <CountList items={CHANNELS} data={channels} prefix="channel" />
  </Panel>
);

export const FoldersPanel = ({ folders }) => (
  <Panel title="Cartelle ordini" icon={FolderOpen} testid="folder-orders-card" to="/sales" action="Gestisci" delay={260}>
    <CountList items={FOLDERS} data={folders} prefix="folder" />
  </Panel>
);
